export default {
  model: {
    'role': 'Role',
    'activeStorage/attachment': 'Attachment',
    'application': 'Application',
    'adminUsersRole': 'Admin user',
    'adminUser': 'Admin user',
    'banner': 'Banner',
    'profile': 'Profile',
    'student': 'Student',
    'member': 'Member',
    'user': 'User',
    'inviteRelationship': 'Invite relationship',
    'activeStorage/blob': 'Resource',
    'actsAsTaggableOn/tag': 'Tag',
    'page': 'Page',
    'presetPage': 'Preset page',
    'staticPage': 'Static page',
    'customPage': 'Custom page',
    'hotWord': 'Hot word',
    'commentableCommentDatum': 'Commentable comment datum',
    'post': 'Post',
    'article': 'Article',
    'customPostList': 'Custom post list',
    'customPostListsPost': 'Custom post lists post',
    'comment': 'Comment',
    'normalComment': 'Normal comment',
    'specialColumn': 'Special column',
    'specialColumnArticleRelation': 'Special column article relation',
    'seekTruthWeekly': 'Seek truth weekly',
    'seekTruthVideo': 'Seek truth video',
    'bookClub': 'Book club',
    'bookList': 'Book list',
    'podcast': 'Podcast',
    'experienceComment': 'Experience comment',
    'reason': 'Reason',
    'applyRecord': 'Apply record',
    'priceType': 'Price type',
    'priceTypeTemplate': 'Price type template',
    'youthCamp': 'Youth camp',
    'invoiceApplyRecord': 'Invoice apply record',
    'youthCampExperienceComment': 'Youth camp experience comment',
    'operationRecord': 'Operation record',
    'setting': 'Setting',
  },
  'role': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    kind: 'Kind',
    kinds: {
      super: 'Super',
      application: 'Application',
      custom: 'Custom',
    },
    customPermissions: 'Custom permissions',
  },
  'activeStorage/attachment': {
    id: 'ID',
    createdAt: 'Created at',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
  },
  'application': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    desc: 'Desc',
    shareDesc: 'Share description',
    shareTitle: 'Share title',
    trackingCodeDesc: 'Tracking code desc',
    displayingVideo: 'Displaying video',
    wechatApplicationId: 'Wechat application',
    auditComment: 'Audit comment',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: 'Share image',
    logo: 'Logo',
    creator: 'Creator',
    posterImage: 'Poster image',
  },
  'adminUsersRole': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    roleId: 'Role',
    adminUserId: 'Admin user',
    applicationId: 'Application',
    role: 'Role',
    application: 'Application',
    adminUser: 'Admin user',
    adminUserAttributes: 'Admin user attributes',
  },
  'adminUser': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    email: 'Email',
    name: 'Name',
    adminUsersRolesAttributes: 'Admin users roles attributes',
  },
  'banner': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    target: 'Target',
    position: 'Position',
    pagePosition: 'Page position',
    pagePositions: {
      book_club: 'Book club',
      youth_camp: 'Youth camp',
    },
    kind: 'Kind',
    kinds: {
      web_link: 'Web link',
      image: 'Image',
      mp_link: 'Mini program link',
    },
    alt: 'Alt',
    image: 'Image',
  },
  'profile': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    gender: 'Gender',
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
  },
  'student': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    bookClubCourseNumbers: 'Book club course numbers',
    city: 'City',
    courseStickiness: 'Course stickiness',
    courseTimes: 'Course times',
    coursesCount: 'Courses count',
    height: 'Height',
    name: 'Name',
    npsList: 'Nps list',
    npsSource: 'Nps source',
    npsValue: 'Nps value',
    occupation: 'Occupation',
    phone: 'Phone',
    weight: 'Weight',
    youthCampCourseNumbers: 'Youth camp course numbers',
    gender: 'Gender',
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
    userId: 'User',
    bridge: 'Bridge',
    holder: 'Holder',
    partner: 'Partner',
    potential: 'Potential',
    student: 'Student',
    user: 'User',
    remark: 'Remark',
  },
  'member': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    company: 'Company',
    knowChannel: 'Know channel',
    liveCity: 'Live city',
    name: 'Name',
    position: 'Position',
    gender: 'Gender',
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
    userId: 'User',
    vaccinationRecordImage: 'Vaccination record image',
    businessExperience: 'Business experience',
  },
  'user': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    screenName: 'Screen name',
    isBlock: 'Is block',
    profile: 'Profile',
    snsAuthorized: 'Sns authorized',
    likePostsCount: 'Like posts count',
    starPostsCount: 'Star posts count',
    viewPostsCount: 'View posts count',
    sharePostsCount: 'Share posts count',
    inviteesCount: 'Invitees count',
    avatar: 'Avatar',
    parentUser: 'Parent user',
    student: 'Student',
    member: 'Member',
    inviteRelationship: 'Invite relationship',
  },
  'inviteRelationship': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    phone: 'Phone',
    parentId: 'Parent',
    userId: 'User',
    remark: 'Remark',
    parent: 'Parent',
    user: 'User',
    children: 'Children',
  },
  'activeStorage/blob': {
    id: 'ID',
    createdAt: 'Created at',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
    tagList: 'Tag list',
  },
  'actsAsTaggableOn/tag': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'page': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    slug: 'Slug',
    title: 'Title',
    type: 'Type',
    applicationId: 'Application',
    viewsCount: 'Views count',
    publishedAt: 'Published at',
    wxacode: 'Wxacode',
    content: 'Content',
  },
  'presetPage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    viewsCount: 'Views count',
    content: 'Content',
  },
  'staticPage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    status: 'Status',
    viewsCount: 'Views count',
    wxacode: 'Wxacode',
    content: 'Content',
  },
  'customPage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    default: 'Default',
    miniProgramPath: 'Mini program path',
    publishedAt: 'Published at',
    formalCustomPageId: 'Formal custom page',
    formalCustomPage: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: 'Configs',
  },
  'hotWord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    position: 'Position',
    applicationId: 'Application',
    application: 'Application',
  },
  'commentableCommentDatum': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    commentsCount: 'Comments count',
    approvedCommentsCount: 'Approved comments count',
    deletedCommentsCount: 'Deleted comments count',
  },
  'post': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    type: 'Type',
    likesCount: 'Likes count',
    viewsCount: 'Views count',
    starsCount: 'Stars count',
    sharesCount: 'Shares count',
    commentsCount: 'Comments count',
    publishedAt: 'Published at',
    author: 'Author',
    source: 'Source',
    shareDesc: 'Share description',
    isTop: 'Is top',
    contentType: 'Content type',
    contentTypes: {
      richtext: 'Richtext',
      markdown: 'Markdown',
    },
    note: 'Note',
    subtitle: 'Subtitle',
    cover: 'Cover',
    commentableCommentDatum: 'Commentable comment datum',
    content: 'Content',
    markdownContent: 'Markdown content',
    recommendPostIds: 'Recommend post ids',
    recommendPosts: 'Recommend posts',
  },
  'article': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    type: 'Type',
    likesCount: 'Likes count',
    viewsCount: 'Views count',
    starsCount: 'Stars count',
    sharesCount: 'Shares count',
    commentsCount: 'Comments count',
    publishedAt: 'Published at',
    author: 'Author',
    source: 'Source',
    shareDesc: 'Share description',
    isTop: 'Is top',
    contentType: 'Content type',
    contentTypes: {
      richtext: 'Richtext',
      markdown: 'Markdown',
    },
    note: 'Note',
    subtitle: 'Subtitle',
    cover: 'Cover',
    commentableCommentDatum: 'Commentable comment datum',
    content: 'Content',
    markdownContent: 'Markdown content',
    recommendPostIds: 'Recommend post ids',
    recommendPosts: 'Recommend posts',
  },
  'customPostList': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    remark: 'Remark',
    title: 'Title',
    customPostListsPosts: 'Custom post lists posts',
    postIds: 'Post ids',
    posts: 'Posts',
  },
  'customPostListsPost': {
    id: 'ID',
    postId: 'Post',
    position: 'Position',
  },
  'comment': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    commentableType: 'Commentable type',
    content: 'Content',
    approvedCommentsCount: 'Approved comments count',
    commentableId: 'Commentable',
    commentsCount: 'Comments count',
    likesCount: 'Likes count',
    state: 'State',
    states: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    creatorId: 'Creator',
    creatorType: 'Creator type',
    deletedAt: 'Deleted at',
    position: 'Position',
    isDeleted: 'Is deleted',
    isTop: 'Is top',
    parentId: 'Parent',
    rootId: 'Root',
    adminRead: 'Admin read',
    creator: 'Creator',
    parent: 'Parent',
    commentable: 'Commentable',
    commentableCommentDatum: 'Commentable comment datum',
  },
  'normalComment': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    commentableType: 'Commentable type',
    content: 'Content',
    approvedCommentsCount: 'Approved comments count',
    commentableId: 'Commentable',
    commentsCount: 'Comments count',
    likesCount: 'Likes count',
    state: 'State',
    states: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    creatorId: 'Creator',
    creatorType: 'Creator type',
    deletedAt: 'Deleted at',
    position: 'Position',
    isDeleted: 'Is deleted',
    isTop: 'Is top',
    parentId: 'Parent',
    rootId: 'Root',
    adminRead: 'Admin read',
    parent: 'Parent',
    commentable: 'Commentable',
    creator: 'Creator',
    commentableCommentDatum: 'Commentable comment datum',
  },
  'specialColumn': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    type: 'Type',
    likesCount: 'Likes count',
    viewsCount: 'Views count',
    starsCount: 'Stars count',
    sharesCount: 'Shares count',
    commentsCount: 'Comments count',
    publishedAt: 'Published at',
    author: 'Author',
    source: 'Source',
    shareDesc: 'Share description',
    isTop: 'Is top',
    contentType: 'Content type',
    contentTypes: {
      richtext: 'Richtext',
      markdown: 'Markdown',
    },
    note: 'Note',
    subtitle: 'Subtitle',
    cover: 'Cover',
    commentableCommentDatum: 'Commentable comment datum',
    content: 'Content',
    markdownContent: 'Markdown content',
    articles: 'Articles',
    specialColumnArticleRelations: 'Special column article relations',
    recommendPostIds: 'Recommend post ids',
    recommendPosts: 'Recommend posts',
  },
  'specialColumnArticleRelation': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    position: 'Position',
    articleId: 'Article',
    article: 'Article',
  },
  'seekTruthWeekly': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    type: 'Type',
    likesCount: 'Likes count',
    viewsCount: 'Views count',
    starsCount: 'Stars count',
    sharesCount: 'Shares count',
    commentsCount: 'Comments count',
    publishedAt: 'Published at',
    author: 'Author',
    source: 'Source',
    shareDesc: 'Share description',
    isTop: 'Is top',
    contentType: 'Content type',
    contentTypes: {
      richtext: 'Richtext',
      markdown: 'Markdown',
    },
    cover: 'Cover',
    content: 'Content',
    markdownContent: 'Markdown content',
    recommendPostIds: 'Recommend post ids',
    recommendPosts: 'Recommend posts',
  },
  'seekTruthVideo': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    type: 'Type',
    likesCount: 'Likes count',
    viewsCount: 'Views count',
    starsCount: 'Stars count',
    sharesCount: 'Shares count',
    commentsCount: 'Comments count',
    publishedAt: 'Published at',
    author: 'Author',
    source: 'Source',
    shareDesc: 'Share description',
    isTop: 'Is top',
    contentType: 'Content type',
    contentTypes: {
      richtext: 'Richtext',
      markdown: 'Markdown',
    },
    note: 'Note',
    subtitle: 'Subtitle',
    cover: 'Cover',
    commentableCommentDatum: 'Commentable comment datum',
    video: 'Video',
  },
  'bookClub': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    type: 'Type',
    likesCount: 'Likes count',
    viewsCount: 'Views count',
    starsCount: 'Stars count',
    sharesCount: 'Shares count',
    commentsCount: 'Comments count',
    publishedAt: 'Published at',
    author: 'Author',
    source: 'Source',
    shareDesc: 'Share description',
    isTop: 'Is top',
    contentType: 'Content type',
    contentTypes: {
      richtext: 'Richtext',
      markdown: 'Markdown',
    },
    number: 'Number',
    lecturer: 'Lecturer',
    startAt: 'Start at',
    endAt: 'End at',
    address: 'Address',
    note: 'Note',
    cover: 'Cover',
    content: 'Content',
    markdownContent: 'Markdown content',
    images: 'Images',
    relatedBookLists: 'Related book lists',
    relatedBookListIds: 'Related book list ids',
  },
  'bookList': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    type: 'Type',
    likesCount: 'Likes count',
    viewsCount: 'Views count',
    starsCount: 'Stars count',
    sharesCount: 'Shares count',
    commentsCount: 'Comments count',
    publishedAt: 'Published at',
    author: 'Author',
    source: 'Source',
    shareDesc: 'Share description',
    isTop: 'Is top',
    contentType: 'Content type',
    contentTypes: {
      richtext: 'Richtext',
      markdown: 'Markdown',
    },
    cover: 'Cover',
    content: 'Content',
    markdownContent: 'Markdown content',
    recommendPostIds: 'Recommend post ids',
    recommendPosts: 'Recommend posts',
  },
  'podcast': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    type: 'Type',
    likesCount: 'Likes count',
    viewsCount: 'Views count',
    starsCount: 'Stars count',
    sharesCount: 'Shares count',
    commentsCount: 'Comments count',
    publishedAt: 'Published at',
    author: 'Author',
    source: 'Source',
    shareDesc: 'Share description',
    isTop: 'Is top',
    contentType: 'Content type',
    contentTypes: {
      richtext: 'Richtext',
      markdown: 'Markdown',
    },
    cover: 'Cover',
    content: 'Content',
    markdownContent: 'Markdown content',
    audio: 'Audio',
    recommendPostIds: 'Recommend post ids',
    recommendPosts: 'Recommend posts',
  },
  'experienceComment': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    commentableType: 'Commentable type',
    content: 'Content',
    approvedCommentsCount: 'Approved comments count',
    commentableId: 'Commentable',
    commentsCount: 'Comments count',
    likesCount: 'Likes count',
    state: 'State',
    states: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    creatorId: 'Creator',
    creatorType: 'Creator type',
    deletedAt: 'Deleted at',
    position: 'Position',
    isDeleted: 'Is deleted',
    isTop: 'Is top',
    parentId: 'Parent',
    rootId: 'Root',
    adminRead: 'Admin read',
    commentable: 'Commentable',
    creator: 'Creator',
    commentableCommentDatum: 'Commentable comment datum',
  },
  'reason': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    kind: 'Kind',
    kinds: {
      refund: 'Refund',
    },
    isActive: 'Is active',
  },
  'applyRecord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    targetType: 'Target type',
    targetId: 'Target',
    userId: 'User',
    state: 'State',
    states: {
      applied: 'Applied',
      paid: 'Paid',
      refund_audit: 'Refund audit',
      refunding: 'Refunding',
      refunded: 'Refunded',
    },
    refundReason: 'Refund reason',
    refundReasonDetail: 'Refund reason detail',
    priceTypeName: 'Price type name',
    priceTypeAmount: 'Price type amount',
    target: 'Target',
    user: 'User',
  },
  'priceType': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    amount: 'Amount',
    priceTypeTemplateId: 'Price type template',
  },
  'priceTypeTemplate': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    priceTypes: 'Price types',
  },
  'youthCamp': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    type: 'Type',
    likesCount: 'Likes count',
    viewsCount: 'Views count',
    starsCount: 'Stars count',
    sharesCount: 'Shares count',
    commentsCount: 'Comments count',
    publishedAt: 'Published at',
    author: 'Author',
    source: 'Source',
    shareDesc: 'Share description',
    isTop: 'Is top',
    contentType: 'Content type',
    contentTypes: {
      richtext: 'Richtext',
      markdown: 'Markdown',
    },
    number: 'Number',
    startAt: 'Start at',
    endAt: 'End at',
    lecturer: 'Lecturer',
    address: 'Address',
    applicantsCount: 'Applicants count',
    priceTypeTemplateId: 'Price type template',
    cover: 'Cover',
    priceTypeTemplate: 'Price type template',
    note: 'Note',
    content: 'Content',
    markdownContent: 'Markdown content',
    images: 'Images',
  },
  'invoiceApplyRecord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    bankAccount: 'Bank account',
    bankName: 'Bank name',
    companyAddress: 'Company address',
    taxNumber: 'Tax number',
    telephone: 'Telephone',
    title: 'Title',
    invoiceType: 'Invoice type',
    invoiceTypes: {
      vat_general_invoice: 'Vat general invoice',
      vat_special_invoice: 'Vat special invoice',
      general_invoice: 'General invoice',
    },
    state: 'State',
    states: {
      pending: 'Pending',
      processing: 'Processing',
      processed: 'Processed',
    },
    titleType: 'Title type',
    titleTypes: {
      individual: 'Individual',
      company: 'Company',
    },
    userId: 'User',
    user: 'User',
    applyRecord: 'Apply record',
    remark: 'Remark',
  },
  'youthCampExperienceComment': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    commentableType: 'Commentable type',
    content: 'Content',
    approvedCommentsCount: 'Approved comments count',
    commentableId: 'Commentable',
    commentsCount: 'Comments count',
    likesCount: 'Likes count',
    state: 'State',
    states: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    creatorId: 'Creator',
    creatorType: 'Creator type',
    deletedAt: 'Deleted at',
    position: 'Position',
    isDeleted: 'Is deleted',
    isTop: 'Is top',
    parentId: 'Parent',
    rootId: 'Root',
    adminRead: 'Admin read',
    creator: 'Creator',
    commentableCommentDatum: 'Commentable comment datum',
  },
  'operationRecord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    content: 'Content',
    contentEn: 'Content en',
    adminUser: 'Admin user',
    previousObject: 'Previous object',
    currentObject: 'Current object',
  },
  'setting': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
  },
}
